/** Alinhado ao interceptor em `api/config/axios.js` — fluxo esperado, não bug de app. */
export const AXIOS_BENIGN_HTTP_STATUSES = new Set([401, 403, 404, 422]);

const LESSON_PROGRESS_PATH = /\/lessons\/[^/]+\/progress$/;
const LESSON_PROGRESS_VIDEO_ONLY_MSG = 'apenas para aulas do tipo vídeo';

/**
 * PUT de progresso em aula que não é vídeo (ex.: timer pendente após troca de aula).
 * Resposta esperada do backend; não deve gerar alerta no Sentry.
 *
 * @param {unknown} error
 */
export function isAxiosBenignLessonProgressTypeMismatch(error) {
    const status = error?.response?.status;
    if (status !== 400) {
        return false;
    }

    const url = String(error?.config?.url || '');
    if (!LESSON_PROGRESS_PATH.test(url)) {
        return false;
    }

    const message = error?.response?.data?.message;
    return typeof message === 'string' && message.includes(LESSON_PROGRESS_VIDEO_ONLY_MSG);
}

/**
 * @param {unknown} error
 */
export function isAxiosBenignHttpError(error) {
    const status = error?.response?.status;
    return typeof status === 'number' && AXIOS_BENIGN_HTTP_STATUSES.has(status);
}

/**
 * Erros Axios que a UI/Sentry podem ignorar como ruído operacional.
 * @param {unknown} error
 */
export function isAxiosBenignError(error) {
    return isAxiosBenignHttpError(error) || isAxiosBenignLessonProgressTypeMismatch(error);
}
